import initFraud from '../initFraud';

const session = require('@flowio/session');
const persistSession = require('@flowio/session/lib/persist-session');
const SessionClient = require('@flowio/session/lib/client');

const config = require('../config');
const optionsSuccess = require('./options-success');
const optionsError = require('./options-error');
const syncCartAttributes = require('./sync-cart-attributes');
const { getCart } = require('../cart_unified/cart-unified');

const sessionClient = new SessionClient({ apiBaseUri: config.API_BASE_URI });

function clearExperience(options = {}) {
  const sessionId = session.getSessionId();

  sessionClient.clearSession({
    integration: 'shopify',
    sessionId,
    onSuccess: (updatedSession) => {
      persistSession(updatedSession);
      initFraud();
      syncCartAttributes(updatedSession, getCart()).then(() => {
        optionsSuccess(options, updatedSession);
      });
    },
    onError: error => optionsError(options, new Error(`Could not update session with new Experience: ${error.message}`)),
  });
}

module.exports = clearExperience;



// WEBPACK FOOTER //
// ./static/js/v0/utilities/clear-experience.js